import { useLocation, useNavigate } from '@hulu/react-router-dom';
import React, { memo, useContext } from 'react';

import { RoutePath } from '../../constants';
import { GlobalPermissionsContext } from '../../context';
import { getMenuItems } from '../../pages/AccountManagement/constants';
import MenuItem from './MenuItem';
import { Tab } from './types';

const SideMenu = (): JSX.Element => {
  const navigate = useNavigate();
  const { permissions } = useContext(GlobalPermissionsContext);
  const { pathname } = useLocation();

  const onItemClick = (url: string): void => {
    navigate(url);
  };

  return (
    <div data-testid="sideMenu">
      {getMenuItems(permissions).map(
        ({ icon, title, url, hidden }: Tab) =>
          !hidden && (
            <div key={url} onClick={(): void => onItemClick(RoutePath.ACCOUNT + url)}>
              <MenuItem icon={icon} title={title} active={pathname.includes(RoutePath.ACCOUNT + url)} />
            </div>
          )
      )}
    </div>
  );
};

export default memo(SideMenu);
